export default __webpack_public_path__ + "logo.d882f48.png";